<template lang="pug">
  .target.targets
    .toolbar
      .line.toolbar__line(style="justify-content: end")
        .actions-panel.view-panel.view-panel_divide
          e-button-add.actions-panel__button.btn-text.button.button_usual(
            @click="showYearModal = true"
            label="Добавить столбец"
            btnDefaultClass=" "
          )
    e-modal(
      v-if="showYearModal"
      title="Выбор года"
      @close="showYearModal = false"
      @confirm="addYearColumn"
    )
      slot
        e-form(:formValidator="formValidator")
          e-form-group(
            name="newYear"
            inputType="select"
            label="Год"
            :model="fields"
            :required="true"
            tabView="tab1"
            :options="yearsOptions"
          )
    .content
      .table.overflow-hidden
        .theader-wrapper
          table(cellspacing="0" style="width: 100%" ref="tableHeader")
            colgroup
              col(v-for="(header, index) in tableHeaders" :key="index" :width="header.width")
            thead
              tr
                th.table__th.semibold(v-for="header in tableHeaders" :key="header.key" :colspan="header.colspan" :rowspan="header.rowspan")
                  .th-block
                    span {{ header.label }}
                    e-button-delete(
                      v-if="header.deletable"
                      @click="removeYearColumn(header.key)"
                    ).reset-btn.button.button_delete.button_small.button_icon
                    e-button-edit(v-if="header.deletable && !header.isEditing" @click="enableEditing(header.key)") Редактировать
                    button.button.button_usual(v-if="header.deletable && header.isEditing" @click="disableEditing(header.key)") Сохранить

        e-perfect-scrollbar(
          ref="tablePS"
          :emitTypes="['vue']"
          @ps-scroll-x="scrollHandler($event.event)"
          :config="{suppressScrollY: false, suppressScrollX: false}"
        )
          .tbody-wrapper(:style="{'max-height':'calc(100vh - 375px)'}")
            table(cellspacing="0" style="width: 100%")
              colgroup
                col(v-for="(header, index) in tableHeaders" :key="index" :width="header.width")
              tbody(ref="tableBody")
                tr(v-for="(row, rowIndex) in tableData" :key="rowIndex")
                  td.table__td(v-for="(header, colIndex) in tableHeaders" :key="colIndex")
                    div(v-if="colIndex === 0") {{ row.name }}
                    span(v-if="colIndex > 0")
                      span(v-if="!row._isEdit[header.key] || !header.isEditing")
                        span(
                          @dblclick="isEditable(colIndex, row) && enableEditing(header.key, row)"
                          :title="isEditable(colIndex, row) ? 'Двойной клик для редактирования' : ''"
                        ) {{ withSpaces(row[header.key]) || '-'}}
                      div(v-else)
                        input.input(
                          type="number"
                          v-model="row[header.key]"
                          :step="1"
                          min="0"
                        )
</template>

<script>
import { map, tko } from '@/api/api-endpoints'
import year from '@/utils/year'
import formBaseMixin from '@/components/form/form-base-mixin'

export default {
  name: 'plannedPurchasesTab',
  mixins: [formBaseMixin],
  props: {
    tko_operator_id: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      fields: {
        newYear: year.getCurrentYear(),
      },
      showYearModal: false,
      tableHeaders: [{ key: 'name', label: 'Наименование', width: 300 }],
      tableData: [
        {
          name: 'Контейнеры',
          key: 'quantity_plan',
          type: 'containers',
          _isEdit: {},
          isEditable: true,
        },
        {
          name: 'Бункеры ',
          key: 'quantity_plan',
          type: 'bunkers',
          _isEdit: {},
          isEditable: true,
        },
        {
          name: 'Общее количество контейнеров и бункеров',
          type: 'total',
          key: 'quantity_plan',
          _isEdit: {},
          isEditable: true,
        },
      ],
    }
  },
  computed: {
    yearsOptions() {
      const yearsInTable = this.tableHeaders
        .filter((header) => header.year)
        .map((header) => header.year)
      return this.$store.state.years
        .filter((year) => !yearsInTable.includes(year))
        .map((year) => ({ id: year, name: year }))
    },
  },
  methods: {
    async disableEditing(headerKey) {
      this.tableHeaders = this.tableHeaders.map((header) => {
        if (header.key === headerKey) {
          header.isEditing = false
        }
        return header
      })
      const isLoadedFromBackend = this.tableHeaders.find(
        (el) => el.key === headerKey
      )?.id

      try {
        if (isLoadedFromBackend) {
          await this.patchData(headerKey)
        } else {
          await this.postData(headerKey)
        }
      } catch (e) {
        console.error(e)
      }

      this.tableData.forEach((row) => {
        if (row.isEditable) {
          this.$set(row._isEdit, headerKey, false)
        }
      })
    },
    async postData(headerKey) {
      for (const el of this.tableData) {
        const dataToPost = {
          type_id: el.type,
          name: el.type,
          year: headerKey.match(/\d{4}/)[0],
          tko_operator_id: this.tko_operator_id,
          quantity_plan: el[headerKey],
        }
        try {
          await this.$store.dispatch('createModel', {
            url: tko.operatorPlannedPurchasesUpdate({
              query: { tko_operator_id: this.tko_operator_id },
            }),
            data: dataToPost,
          })
        } catch (error) {
          throw new Error('Ошибка при PATCH-запросе')
        }
      }
      await this.fetchData()
    },
    async patchData(headerKey) {
      for (const el of this.tableData) {
        if (el[headerKey] !== '' && el[headerKey] !== undefined) {
          const dataToPatch = {
            quantity_plan: el[headerKey],
          }

          try {
            await this.$store.dispatch('updateModel', {
              url: tko.operatorPlannedPurchasesById(el[`${headerKey}Id`]), // обновляем с указанным id
              data: dataToPatch,
            })
          } catch (error) {
            console.error('Ошибка при PATCH-запросе', error)
          }
        }
      }
      await this.fetchData()
    },
    async fetchData() {
      try {
        const response = await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: this.getEndpoint(),
        })
        const data = response.data.data
        this.tableHeaders = [{ key: 'name', label: 'Наименование', width: 300 }]
        // Массив уникальных лет, которые уже присутствуют в заголовках
        const existingYears = this.tableHeaders.map((header) => header.year)

        data.forEach((item) => {
          const yearKey = `year_${item.year}`
          const yearKeyId = `year_${item.year}Id`

          // Проверяем, существует ли уже столбец для этого года
          if (!existingYears.includes(item.year)) {
            this.tableHeaders.push({
              key: yearKey,
              label: item.year,
              width: 150,
              year: item.year,
              type: item.type_id,
              deletable: true,
              isEditing: false,
              // id в заголовке колонке если пришло с бэка
              id: item.id,
            })
            existingYears.push(item.year) // Добавляем год в список существующих лет
          }

          // Заполняем данные для строк в зависимости от типа (containers, bunkers и total)
          this.tableData.forEach((row) => {
            if (row.type === item.type_id) {
              this.$set(row, yearKey, item.quantity_plan) // Подставляем данные для соответствующего типа
              this.$set(row, yearKeyId, item.id)
            }
            this.$set(row._isEdit, yearKey, false)
          })
        })

        this.tableHeaders.sort((a, b) => {
          if (a.year && b.year) {
            return a.year - b.year
          }
          return 0
        })
      } catch (e) {
        console.error(e)
      }
    },
    getEndpoint() {
      const tkoOperatorId = this.tko_operator_id
      return tko.operatorPlannedPurchases({
        query: { tko_operator_id: tkoOperatorId },
      })
    },
    addYearColumn() {
      const yearKey = `year_${this.fields.newYear}`
      this.tableHeaders.push({
        key: yearKey,
        label: this.fields.newYear,
        width: 150,
        year: this.fields.newYear,
        deletable: true,
        isEditing: true,
      })

      this.tableHeaders.sort((a, b) => {
        if (a.year && b.year) {
          return a.year - b.year
        }
        return 0
      })

      this.tableData.forEach((row) => {
        row[yearKey] = ''
        this.$set(row._isEdit, yearKey, true)
      })
      this.showYearModal = false
    },
    async removeYearColumn(year) {
      for (const el of this.tableData) {
        const id = el[`${year}Id`]
        if (id) {
          try {
            await this.$store.dispatch('deleteModel', {
              url: tko.operatorPlannedPurchasesById(id),
            })
          } catch (e) {
            console.error(e)
          }
        }
      }

      // Удаляем столбца из tableHeaders
      this.tableHeaders = this.tableHeaders.filter(
        (header) => header.key !== year
      )
      this.tableData.forEach((row) => {
        this.$delete(row, year)
        this.$delete(row._isEdit, year)
      })

      await this.fetchData()
    },
    scrollHandler(event) {
      let { scrollLeft = 0 } = event.target
      this.$refs.tableHeader.style.marginLeft = `-${scrollLeft}px`
    },
    getYears() {
      this.$store
        .dispatch('updateUrlEndpoint', {
          endpoint: map.yearFuture(),
          fromCache: true,
        })
        .then((r) => {
          let _yearsOptions = []
          r.data.year.forEach((i) => {
            _yearsOptions.push(i.year)
          })
          this.$store.commit('setYears', _yearsOptions)
        })
        .catch((e) => {
          console.error(e)
        })
    },
    isEditable(colIndex, row) {
      return colIndex > 0 && row.isEditable
    },
    enableEditing(columnKey) {
      this.tableHeaders = this.tableHeaders.map((header) => {
        if (header.key === columnKey) {
          header.isEditing = true
        }
        return header
      })

      this.tableData.forEach((row) => {
        if (row.isEditable) {
          this.$set(row._isEdit, columnKey, true)
        }
      })
    },
    withSpaces(value) {
      return value.toLocaleString()
    },
  },
  mounted() {
    if (this.tko_operator_id) {
      this.fetchData()
    } else {
      this.$watch('tko_operator_id', (newVal) => {
        if (newVal) {
          this.fetchData()
        }
      })
    }
    this.getYears()
  },
}
</script>
<style scoped lang="scss">
.table__td {
  padding: 15px 10px;
  background-color: #fff;
  border-right: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
}

.th-block {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  text-align: center;
  gap: 5px;
  box-sizing: border-box;
}
</style>
